import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import client from '../api/client';
import './NewProject.css';

export default function NewProject() {
  const [form, setForm] = useState({ name: '', description: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const set = (k: string) => (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
    setForm(f => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const r = await client.post('/api/armundi/projects', form);
      navigate(`/projects/${r.data.id}`);  // ← war: r.data.project.id
    } catch (err: any) {
      setError(err.response?.data?.error || 'Fehler beim Erstellen.');
      setLoading(false);
    }
  };

  return (
    <div className="new-project-page">
      <div className="breadcrumb">
        <Link to="/projects">Projekte</Link>
        <span>/</span>
        <span>Neues Projekt</span>
      </div>

      <h1 className="page-title">Neues Projekt</h1>

      <div className="form-card">
        {error && <div className="form-error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Projektname *</label>
            <input
              value={form.name}
              onChange={set('name')}
              placeholder="z.B. Rathaus Musterstadt"
              required
              autoFocus
            />
          </div>
          <div className="form-group">
            <label>Beschreibung</label>
            <textarea
              value={form.description}
              onChange={set('description') as any}
              placeholder="Optionale Beschreibung..."
              rows={3}
            />
          </div>
          <div className="form-actions">
            <Link to="/projects" className="btn-secondary">Abbrechen</Link>
            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? 'Wird erstellt...' : 'Projekt erstellen'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
